import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import mapStyleToClassName from 'utils/mapStyleToClassName'
import styles from './notification.css'

class Notification extends PureComponent {
  render () {
    const { style, message } = this.props

    const className = mapStyleToClassName(styles, style)

    return (
      <div className={className}>
        { message }
      </div>
    )
  }
}

Notification.propTypes = {
  /** Variants: 'error', 'success', 'info' */
  style: PropTypes.shape({
    variant: PropTypes.oneOf(['error', 'success', 'info'])
  }),
  message: PropTypes.string.isRequired
}

Notification.defaultProps = {
  style: {
    variant: 'error'
  }
}

export default Notification
